export const cookieNames = [
  'userSelectedAmount',
  'email',
  'cardLastFourDigit',
  'cardType',
  'fullName',
  'cityStateZip',
  'address',
  'apartment',
  'quotationOrSalesId',
  'syfDetails',
  'selectedPaymentOption',
  'progressiveDetails',
];

export function setDocCookies(
  cookieData: Partial<Record<string, string | number | boolean | undefined>>,
  options: {
    expires?: string;
    secure?: boolean;
    sameSite?: 'Strict' | 'Lax' | 'None';
  } = {},
  key?: string,
): void {
  const buildCookieString = (
    name: string,
    value: string | number | boolean,
  ): string => {
    let cookieStr = `${encodeURIComponent(name)}=${encodeURIComponent(String(value))}; path=/;`;

    if (options.expires) {
      cookieStr += ` expires=${options.expires};`;
    }
    if (options.secure) {
      cookieStr += ' Secure;';
    }
    if (options.sameSite) {
      cookieStr += ` SameSite=${options.sameSite};`;
    }

    return cookieStr;
  };

  if (key) {
    const value = cookieData[key];
    if (value) {
      document.cookie = buildCookieString(key, value);
    }
  }

  Object.entries(cookieData).forEach(([name, value]) => {
    if (value) {
      document.cookie = buildCookieString(name, value);
    }
  });
}

export function getDocCookie(key: string): string | undefined {
  const name = `${encodeURIComponent(key)}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookieArray = decodedCookie.split(';');

  for (let i = 0; i < cookieArray.length; i++) {
    const cookie = cookieArray[i].trim();
    if (cookie.indexOf(name) === 0) {
      return cookie.substring(name.length, cookie.length);
    }
  }
  return undefined;
}

export function deleteDocCookies(
  name?: string,
  options: { secure?: boolean; sameSite?: 'Strict' | 'Lax' | 'None' } = {},
): void {
  const expires = 'Thu, 01 Jan 1970 00:00:00 GMT';

  if (name) {
    document.cookie = `${encodeURIComponent(name)}=; expires=${expires}; path=/;`;
    return;
  }

  cookieNames.forEach((cookieName) => {
    let cookieString = `${encodeURIComponent(cookieName)}=; expires=${expires}; path=/;`;

    if (options.secure) {
      cookieString += ' Secure;';
    }
    if (options.sameSite) {
      cookieString += ` SameSite=${options.sameSite};`;
    }

    document.cookie = cookieString;
  });
}
